// src/services/construction.js
// API service for Construction Sentry endpoints
import api from './api';

// ── Projects ────────────────────────────────────────────────────────────────
export const getProjects = (params = {}) =>
  api.get('/construction/projects/', { params });

export const getProject = (id) =>
  api.get(`/construction/projects/${id}`);

export const createProject = (data) =>
  api.post('/construction/projects/', data);

export const updateProject = (id, data) =>
  api.put(`/construction/projects/${id}`, data);

export const deleteProject = (id) =>
  api.delete(`/construction/projects/${id}`);

export const getProjectDashboard = (id) =>
  api.get(`/construction/projects/${id}/dashboard`);

// ── Cameras ─────────────────────────────────────────────────────────────────
export const getCameras = (params = {}) =>
  api.get('/construction/cameras/', { params });

export const getCamera = (id) =>
  api.get(`/construction/cameras/${id}`);

export const createCamera = (data) =>
  api.post('/construction/cameras/', data);

export const updateCamera = (id, data) =>
  api.put(`/construction/cameras/${id}`, data);

export const deleteCamera = (id) =>
  api.delete(`/construction/cameras/${id}`);

export const testCamera = (id) =>
  api.post(`/construction/cameras/${id}/test`);

// ── Zones ───────────────────────────────────────────────────────────────────
export const getZones = (params = {}) =>
  api.get('/construction/zones/', { params });

export const getZone = (id) =>
  api.get(`/construction/zones/${id}`);

export const createZone = (data) =>
  api.post('/construction/zones/', data);

export const updateZone = (id, data) =>
  api.put(`/construction/zones/${id}`, data);

export const deleteZone = (id) =>
  api.delete(`/construction/zones/${id}`);

// ── Workers ─────────────────────────────────────────────────────────────────
export const getWorkers = (params = {}) =>
  api.get('/construction/workers/', { params });

export const getWorker = (id) =>
  api.get(`/construction/workers/${id}`);

export const createWorker = (data) =>
  api.post('/construction/workers/', data);

export const updateWorker = (id, data) =>
  api.put(`/construction/workers/${id}`, data);

export const deleteWorker = (id) =>
  api.delete(`/construction/workers/${id}`);

// ── Safety Events ───────────────────────────────────────────────────────────
export const getSafetyEvents = (params = {}) =>
  api.get('/construction/events/', { params });

export const getSafetyEvent = (id) =>
  api.get(`/construction/events/${id}`);

export const updateEventStatus = (id, data) =>
  api.put(`/construction/events/${id}/status`, data);

export const getEventReport = (params = {}) =>
  api.get('/construction/events/report', { params });

// ── Compliance ──────────────────────────────────────────────────────────────
export const getDailyReports = (projectId, params = {}) =>
  api.get(`/construction/compliance/${projectId}/daily`, { params });

export const getDailyReport = (projectId, date) =>
  api.get(`/construction/compliance/${projectId}/daily/${date}`);

export const getComplianceSummary = (projectId) =>
  api.get(`/construction/compliance/${projectId}/summary`);

export const generateDailyReport = (projectId) =>
  api.post(`/construction/compliance/${projectId}/generate`);
